import LiveToolbarIcon from "./LiveToolbarIcon";
import { ReactNode, useState } from 'react';
import styled from 'styled-components';
import LiveChatDownload from './LiveChatDownload';
import LiveChatManagement from './LiveChatManagement';
import LiveQaManagement from './LiveQaManagement';
import { AdminActionButton } from '../../../../Component/UI/AdminPageHeader';

export default function LiveChatPanel({ chatRef, liveSeq, onOpenNotice, notices }: {
  chatRef: (node: HTMLDivElement | null) => void;
  liveSeq: number;
  onOpenNotice?: () => void;
  notices?: ReactNode;
}) {
  const [feedbackTarget, setFeedbackTarget] = useState<HTMLDivElement | null>(null);
  return <Panel aria-label="실시간 라이브 채팅">
    {notices}
    <Header><h2>라이브 채팅</h2><Actions><LiveChatManagement /><LiveQaManagement liveSeq={liveSeq} />
      {onOpenNotice && <AdminActionButton type="button" aria-haspopup="dialog" onClick={onOpenNotice}><LiveToolbarIcon name="notice" />공지</AdminActionButton>}
      <LiveChatDownload liveSeq={liveSeq} feedbackTarget={feedbackTarget} /></Actions></Header>
    <Feedback ref={setFeedbackTarget} />
    <Messages ref={chatRef} />
  </Panel>;
}

const Panel = styled.section`
  flex: 1;
  box-sizing: border-box; display: flex; flex-direction: column; gap: var(--space-2);
  min-height: 0; min-width: 0; padding: var(--live-card-padding-block, var(--space-4)) var(--space-4);
  border: 1px solid var(--color-border-default); border-radius: var(--radius-lg);
  background: var(--color-bg-surface); color: var(--color-text-primary);
  font-size: var(--text-body-lg);
  @media (max-width: 900px) { position: static; min-height: 0; }
`;
const Header = styled.div`
  display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: var(--space-2);
  h2 { margin: 0; font-size: var(--text-h3); font-weight: 600; }
`;
const Actions = styled.div`
  display: flex; flex-wrap: wrap; align-items: center; gap: var(--space-1);
  && ${AdminActionButton} {
    min-height: var(--control-sm); height: var(--control-sm); padding: 0 var(--space-2);
    gap: var(--gap-icon); font-size: var(--text-caption);
    svg { width: var(--space-4); height: var(--space-4); }
  }
  @media (pointer: coarse) {
    && ${AdminActionButton} { min-width: var(--touch-target); min-height: var(--touch-target); height: var(--touch-target); }
  }
`;
const Feedback = styled.div`&:empty { display: none; }`;
const Messages = styled.div`flex: 1; min-height: 0; border-top: 1px solid var(--color-border-default); padding-top: var(--space-2);`;
